import { Box } from '@chakra-ui/react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Modal, Typography } from '@mui/material';
import { IconBellMinus, IconEdit, IconTrashX, IconUserCircle } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/it';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ModalEdit from './modalEdit';
import { toast } from 'react-toastify';

const ModalDetails = ({ modalOpen, handleModalClose, review }) => {
  let [reviewData, setReviewData] = useState(null);
  let [editMode, setEditMode] = useState(false);
  let [deleteMode, setDeleteMode] = useState(false);
  let [ignoreMode, setIgnoreMode] = useState(false);
  let [patient, setPatient] = useState(null);
  let [doctor, setDoctor] = useState(null);
  let [reports, setReports] = useState(null);
  let [appointment, setAppointment] = useState(null);

  const { onGetDoctorReview, onSetIgnoredReviewReports, onSetHiddenReview } = useAccounts();

  const getReview = () => {
    onGetDoctorReview({ review_id: review?.id }).then((res) => {
      setReviewData(res);
      setPatient(res?.appointment?.patient);
      setDoctor(res?.appointment?.calendar?.doctor);
      setAppointment(res?.appointment);
      setReports(res?.report);
    });
  };

  useEffect(() => {
    if (!review) return;
    getReview();
  }, [review]);

  const handleDeleteReview = () => {
    onSetHiddenReview({ review_id: reviewData?.id }).then((res) => {
      getReview();
      handleModalClose();
      toast(res?.response, {
        style: {
          fontSize: '14px',
          backgroundColor: '#00e676',
          color: '#ffffff'
        }
      });
    });
  };

  const handleIgnoreReview = () => {
    onSetIgnoredReviewReports({ review_id: reviewData?.id }).then((res) => {
      getReview();
      toast(res?.response, {
        style: {
          fontSize: '14px',
          backgroundColor: '#00e676',
          color: '#ffffff'
        }
      });
    });
  };

  const handleModalEditClose = () => {
    setEditMode(false);
    getReview();
  };

  return (
    <Modal
      open={modalOpen}
      onClose={handleModalClose}
      allowFullScreen={true}
      className={'modal'}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box w={'100%'} h={'100%'} bg={'transparent'} display={'flex'} justifyContent={'center'} alignItems={'center'} pointerEvents={'none'}>
        <Dialog open={deleteMode} onClose={() => setDeleteMode(false)}>
          <DialogTitle>Elimina Recensione</DialogTitle>
          <DialogContent>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <DialogContentText>Vuoi eliminare questa recensione?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant={'contained'} color={'error'} onClick={() => setDeleteMode(false)}>
              Annulla
            </Button>
            <Button
              variant={'contained'}
              color={'success'}
              onClick={() => {
                handleDeleteReview();
                setDeleteMode(false);
              }}
            >
              Conferma
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={ignoreMode} onClose={() => setIgnoreMode(false)}>
          <DialogTitle>Ignora Segnalazioni</DialogTitle>
          <DialogContent>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <DialogContentText>Vuoi rimuovere le segnalazioni?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant={'contained'} color={'error'} onClick={() => setIgnoreMode(false)}>
              Annulla
            </Button>
            <Button
              variant={'contained'}
              color={'success'}
              onClick={() => {
                handleIgnoreReview();
                setIgnoreMode(false);
              }}
            >
              Conferma
            </Button>
          </DialogActions>
        </Dialog>

        <ModalEdit handleModalClose={handleModalEditClose} modalOpen={editMode} reviewData={reviewData} />
        <Box
          className={'container'}
          w={'85%'}
          h={'70%'}
          bg={'white'}
          borderRadius={'20px'}
          pointerEvents={'all'}
          position={'relative'}
          overflow={'hidden'}
        >
          <Box className={'top_data'} h={'calc(100% - 50px)'} overflow={'auto'}>
            <Box
              position={'absolute'}
              top={'2%'}
              right={'2%'}
              w={'20px'}
              h={'20px'}
              bg={'lightgrey'}
              borderRadius={'20px'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
              fontWeight={'bold'}
              cursor={'pointer'}
              onClick={handleModalClose}
            >
              <Typography>X</Typography>
            </Box>

            <Typography id="modal-modal-title" variant="h4" mt={4} ml={1.5}>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Dettagli Appuntamento:
            </Typography>
            <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
              <CalendarMonthIcon stroke={1.5} size="1.3rem" />
              <Box ml={10}>
                <Typography id="modal-modal-description" variant="body1" fontWeight={'bold'}>
                  {doctor?.name} {doctor?.surname}
                </Typography>
                <Typography id="modal-modal-description" variant="body1">
                  {moment(appointment?.date).locale('it').format('DD/MM/YY')} -{' '}
                  <span
                    style={{
                      fontStyle: 'italic'
                    }}
                  >
                    {appointment?.treatment?.name}{' '}
                  </span>
                </Typography>
                <Typography id="modal-modal-description" variant="body1">
                  {appointment?.calendar?.office?.name} - {appointment?.calendar?.office?.city?.name}
                </Typography>
              </Box>
            </Box>
            <Typography id="modal-modal-title" variant="h4" mt={1} ml={1.5}>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Recensione di:
            </Typography>
            <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
              <IconUserCircle stroke={1.5} size="1.3rem" />
              <Box ml={10}>
                <Typography id="modal-modal-description" variant="body1">
                  {patient?.name} {patient?.surname}
                </Typography>
                <a href={`tel:${patient?.phone_country?.dial_code}${patient?.phone}`}>
                  <Typography id="modal-modal-description">
                    {patient?.phone_country?.dial_code} {patient?.phone}
                  </Typography>
                </a>
                <Typography id="modal-modal-description">{patient?.email}</Typography>
              </Box>
            </Box>
            {reports?.length > 0 && (
              <>
                <Typography id="modal-modal-title" variant="h4" mt={1} ml={1.5}>
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  Segnalato da:
                </Typography>
                <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                  <IconUserCircle stroke={1.5} size="1.3rem" />
                  <Box ml={10}>
                    {reports?.length > 1 ? (
                      <Typography id="modal-modal-description" variant="body1">
                        Segnalato da {reports?.length} utenti
                      </Typography>
                    ) : (
                      <>
                        <Typography id="modal-modal-description" variant="body1">
                          {reports?.[0]?.reporter?.name} {reports?.[0]?.reporter?.surname}
                        </Typography>
                        <a href={`tel:${reports?.[0]?.reporter?.phone_country?.dial_code}${reports?.[0]?.reporter?.phone}`}>
                          <Typography id="modal-modal-description">
                            {reports?.[0]?.reporter?.phone_country?.dial_code} {reports?.[0]?.reporter?.phone}
                          </Typography>
                        </a>
                        <Typography id="modal-modal-description">{reports?.[0]?.reporter?.email}</Typography>
                      </>
                    )}
                  </Box>
                </Box>
              </>
            )}
            <Typography id="modal-modal-title" variant="h4" mt={1} ml={1.5}>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Recensione:
            </Typography>
            <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
              <Box ml={10}>
                <Typography id="modal-modal-description" variant="body1" fontWeight={'bold'}>
                  Stelle: {reviewData?.rating}
                </Typography>
                <Typography id="modal-modal-description">{reviewData?.review}</Typography>
              </Box>
            </Box>
          </Box>
          <Divider />
          <Box
            className={'bottom_buttons'}
            h={'50px'}
            position={'absolute'}
            bottom={0}
            w={'100%'}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            px={20}
          >
            <Button
              variant={'contained'}
              style={{
                backgroundColor: 'grey',
                color: 'white'
              }}
              onClick={() => setIgnoreMode(true)}
            >
              <IconBellMinus stroke={1.5} size="1rem" />
            </Button>
            <Button variant={'contained'} onClick={() => setEditMode(true)}>
              <IconEdit stroke={1.5} size="1rem" />
            </Button>
            <Button variant={'contained'} color={'error'} onClick={() => setDeleteMode(true)}>
              <IconTrashX stroke={1.5} size="1rem" />
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
export default ModalDetails;
